module.exports = __webpack_public_path__ + "img/open.8c3340a.png";